module.exports = __webpack_public_path__ + "131a0a650074214f9048fca6158507c8.svg";